import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Params } from '@angular/router';

import { EventDetailsConfig, SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { firstValueFrom } from 'rxjs';

import { StylesLazyLoadingService } from '../deferred/styles/style-loading.service';
import { DetailedEventViewModel } from '../event-details-common/event-details-common.models';
import { EventDetailsViewModelFetcher } from '../event-details-common/event-details-view-model-fetcher.service';
import { WidgetContextService } from '../widget/common/widget-context.service';
import { BaseEventDetailsResolver } from './base-event-details.resolver';
import { NavigationLayoutService } from './navigation-layout.service';

@Injectable({ providedIn: 'root' })
export class EventDetailsResolver extends BaseEventDetailsResolver {
    constructor(
        protected override navLayoutService: NavigationLayoutService,
        protected override eventDetailsViewModelResolver: EventDetailsViewModelFetcher,
        private stylesService: StylesLazyLoadingService,
        public override sitecoreEventDetails: SitecoreEventDetailsConfig,
        private eventDetailsConfig: EventDetailsConfig,
        private context: WidgetContextService,
    ) {
        super(navLayoutService, eventDetailsViewModelResolver, sitecoreEventDetails);
    }

    override async resolve(route: ActivatedRouteSnapshot): Promise<DetailedEventViewModel> {
        return super.resolve(route);
    }

    async loadStyles(): Promise<void> {
        await this.stylesService.lazyLoad('event-details');
    }

    preResolve(route: ActivatedRouteSnapshot) {
        super.baseResolve(route);
    }

    modalResolve(route: ActivatedRouteSnapshot): Promise<DetailedEventViewModel> {
        return super.baseResolve(route);
    }

    async extendViewModel(route: ActivatedRouteSnapshot, detailedViewModel: DetailedEventViewModel): Promise<DetailedEventViewModel> {
        if (this.eventDetailsConfig.enableEventPageModular) {
            const updatedParams: Params = {
                ...route.params,
                fixtureStage: detailedViewModel.fixture?.stage,
                sport: detailedViewModel.fixture?.sport.id,
                region: detailedViewModel.fixture?.region.id,
                league: detailedViewModel.fixture?.competition.id,
                isVirtual: detailedViewModel.fixture?.isVirtual,
                virtualCompetitionGroup: detailedViewModel.virtualCompetitionDetails?.group,
            };
            const updatedRoute: ActivatedRouteSnapshot = <ActivatedRouteSnapshot>{
                ...route,
                params: updatedParams,
            };
            detailedViewModel.widgetLayoutResponse = await firstValueFrom(
                this.context.getLayout(this.context.getContext({ snapshot: updatedRoute })),
            );
        }

        return detailedViewModel;
    }
}
